import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'controlPanel.title',
    defaultMessage: 'Control panel',
  },
  pendingTasks: {
    id: 'controlPanel.pendingTasks',
    defaultMessage: 'Tasks history',
  },
  to: {
    id: 'controlPanel.to',
    defaultMessage: 'to',
  },
  finished: {
    id: 'controlPanel.finished',
    defaultMessage: 'finished',
  },
  see: {
    id: 'controlPanel.see',
    defaultMessage: 'see',
  },
  seemore: {
    id: 'controlPanel.seemore',
    defaultMessage: 'See more',
  },
  loading: {
    id: 'controlPanel.loading',
    defaultMessage: 'Loading',
  },
  comments: {
    id: 'controlPanel.comments',
    defaultMessage: 'Comments',
  },
  executedBy: {
    id: 'controlPanel.executedBy',
    defaultMessage: 'Executed by',
  },
});
